<template>
  <svg :width="width" :height="height">
    <g :transform="graphTransform">
      <g :transform="'translate(' + translateLeft + ',' + translateTop + ')'" >
        <g
           v-for="d in pieData"
           class="arc" :key="d.index" >
          <popover
             :content="label(d.data) + ': ' + yFormatter(d.value)"
             :delay="100"
             :hideDelay="100" >
            <path
               :class="selectableClass(d, ['slice', 'hoverable'])"
               :d="arc(d)"
               :fill="color(d.index)"
               :data-i="d.index"
               @click="handleSelect(d)" />
          </popover>
        </g>
      </g>
      <template v-if="showLegend" >
        <draggable v-if="draggableLegend" ref="draggableLegend" >
          <graph-legend :keys="keyColors" :x="graphWidth - legendWidth" :width="legendWidth" >
          </graph-legend>
        </draggable>
        <graph-legend v-else :keys="keyColors" :x="graphWidth - legendWidth" :width="legendWidth" >
        </graph-legend>
      </template>
    </g>
  </svg>
</template>

<style scoped>
.slice {
    opacity: 0.7;
}
.slice:hover {
    opacity: 1;
}

.slice.selected {
    stroke: red
}
</style>

<script>
import * as d3 from 'd3'
import * as d3Chromatic from 'd3-scale-chromatic'
import Graph from './Graph.vue'
import margin from '../mixins/margin.js'
import selectable from '../mixins/selectable.js'
import OrthogonalAxes from './OrthogonalAxes.vue'
import Popover from 'd3vue/components/Popover.vue'
import DraggableLegend from '../mixins/draggable-legend.js'

export default {
  extends: Graph,
  mixins: [
    margin,
    selectable,
    DraggableLegend
  ],
  components: {
    Popover: Popover
  },
  props: {
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 500
    },
    sort: {
      default: null
    },
    value: {
      type: Function,
      default: d => d.value
    },
    label: {
      type: Function,
      default: d => d.label
    },
    labelMode: {
      type: String,
      default: 'none'
    },
    startAngle: {
      type: Number,
      default: 0
    },
    endAngle: {
      type: Number,
      default: 2 * Math.PI
    },
    padAngle: {
      type: Number,
      default: 0
    },
    inner: {
      type: Number,
      default: 0
    },
    colorScale: {
      default: () => {
        return d3.scaleSequential(d3Chromatic.interpolateRainbow)
      }
    }
  },
  computed: {
    radius () {
      return Math.min(this.graphWidth, this.graphHeight) / 2
    },
    arcFunc () {
      return d3
        .arc()
        .innerRadius(this.inner * this.radius / 100)
        .outerRadius(this.radius)
    },
    color () {
      return this.colorScale.domain([0, this.data.length])
    },
    pie () {
      return d3
        .pie()
        .value(this.value)
        .startAngle(this.startAngle)
        .endAngle(this.endAngle)
        .padAngle(this.padAngle)
    },
    pieData () {
      return this.pie(this.data)
    },
    keyColors () {
      return this.pieData.map(d => {
        return {
          label: this.label(d.data),
          color: this.color(d.index)
        }
      })
    },
    translateLeft () {
      return this.graphWidth / 2
    },
    translateTop () {
      return this.graphHeight / 2
    }
  },
  methods: {
    selectKey (d) {
      return d.label
    },
    selectData (d) {
      return d.data
    },
    update (val) {
      this.color.domain([0, this.data.length])
    },
    arc (val) {
      return this.arcFunc(val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/d3vue/components/Pie.vue